import { vappContainer, VApplication } from '../../../../../application';
import { logger as log } from '@common/logger';
import { PaymentTransactionPageService } from '../../../services';

const MODULE_NAME = 'profile.machines.states.paymentTxnReport';

const getSrv = () => {
  return vappContainer.get<PaymentTransactionPageService>(
    PaymentTransactionPageService.displayName
  );
};

export const paymentTxnReport = async (context: any, event: any) => {
  const currentState = 'DOWNLOAD_PAYMENT_CSV';
  const method = 'revokeCred';
  log.log("profile.machines.states.paymentTxnReport")
  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.getPaymentTxnReport(event?.payload);
      if (content) {
        return resolve({
          key: 'DOWNLOAD_PAYMENT_CSV_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'User deletion failed';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'DOWNLOAD_PAYMENT_CSV_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'DOWNLOAD_PAYMENT_CSV_FAILED',
        value: _msg,
      });
    }
  });
};
